import React from 'react';
import css from "../Components/Navbar.module.css";
import {NavbarItem} from "../Components/NavbarItem/NavbarItem";
import {IconWithRotation} from "../../../shared";
import {ArrowDown} from "../index";

const NavbarMobile = ({items=[]}) => {
    const mainItems = items.filter(item => item.group !== "footer");
    const footerItems = items.filter(item => item.group === "footer");

    return (
            <div className={css.Navbar}>
                <div className={css.main_group}>
                    {mainItems.map((item, index) =>
                        <NavbarItem key={index}
                                    item={item}
                                    depthLevel={0}
                        >
                            <IconWithRotation component={ArrowDown}/>
                        </NavbarItem>)}
                </div>
                {footerItems.length > 0 && (
                    <div className={css.footer_group}>
                        {footerItems.map((item, index) =>
                            <NavbarItem key={`footer-${index}`}
                                        item={item}
                                        depthLevel={0}
                            >
                                <IconWithRotation component={ArrowDown}/>
                            </NavbarItem>)}
                    </div>
                )}
            </div>
    );
};

export {NavbarMobile};